<ng-template #selectedRowsTpl>
  <div class="flex items-center gap-2">
    @if (isContactManagement) {
      <div>
        <span>Selected</span>
        <span class="text-primary-600 font-semibold"> {{ selectedRows }}</span>
      </div>
      <div class="divider"></div>
      <span class="text-primary-600 font-semibold cursor-pointer" (click)="onUnSelectAllRows()">Unselect All</span>
      <!-- <div class="divider"></div>
      <span class="text-primary-600 font-semibold cursor-pointer" (click)="onShowSelectRange()">Select range</span>
      <p-dialog
        [header]="'Select Range'"
        [(visible)]="isVisibleSelectRange"
        [draggable]="false"
        [focusOnShow]="false"
        [modal]="true"
        [style]="{ width: '480px', height: '300px' }"
        (onHide)="onHideSelectRange()">
        <div [formGroup]="selectRangeForm" class="flex flex-col gap-4">
          <div class="flex flex-col gap-2">
            <span class="font-semibold text-4">Select contacts throught page name</span>
            <span class="text-primary-600">Selected {{ selectedRows }} contacts</span>
          </div>
          <div class="flex gap-2">
            <app-form-control
              class="w-full"
              [label]="'From page'"
              [required]="true"
              [floatLabel]="false"
              [control]="selectRangeForm.controls['from']">
              <input
                placeholder="Enter number page"
                type="number"
                input
                pInputText
                formControlName="from"
                class="w-full" />
            </app-form-control>
            <app-form-control
              class="w-full"
              [label]="'To page'"
              [required]="true"
              [floatLabel]="false"
              [control]="selectRangeForm.controls['to']">
              <input
                placeholder="Enter number page"
                type="number"
                input
                pInputText
                [min]="this.selectRangeForm.value.from || 0"
                formControlName="to"
                class="w-full" />
            </app-form-control>
          </div>
        </div>
        <div class="p-dialog-footer app-dialog-footer">
          <app-button label="Cancel" variant="outline-secondary" size="xl" (onClick)="onCancel()"></app-button>
          <app-button label="Apply" variant="primary" size="xl" (onClick)="onSelectRange()"></app-button>
        </div>
      </p-dialog> -->
    } @else {
      <span>{{ selectedRows }} selected</span>
      <div class="divider"></div>
      <div type="button" (click)="onSelectAllRows()" class="cursor-pointer">
        <span class="text-primary-600">Select all</span>
      </div>
    }
    <div *ngIf="selectedRowsAction">
      <ng-container *ngTemplateOutlet="selectedRowsAction"></ng-container>
    </div>
  </div>
</ng-template>

<!-- @if (selectedRows > 0 && isNewUI && totalRecords <= 5) {
  <ng-container *ngTemplateOutlet="selectedRowsTpl"></ng-container>
} -->

<div
  [ngClass]="{
    'bg-primary-500/10 py-2 px-4 rounded': isNewUI,
    'bg-white h-8': !isNewUI,
    'flex justify-between': isNewUI && selectedRows > 0
  }">
  @if (selectedRows > 0 && isNewUI) {
    <ng-container *ngTemplateOutlet="selectedRowsTpl"></ng-container>
  }
  <div class="flex items-center gap-2" [ngClass]="isNewUI ? 'justify-end' : 'justify-between'">
    <!-- Total data -->
    @if (isNewUI) {
      <div>
        Total
        <b>{{ totalRecords }}</b>
        {{ module }}
      </div>

      <div class="divider"></div>

      @if (totalRecords) {
        <div>
          Page <b class="text-primary-600">{{ pagination.page + 1 }}</b> of
          <b class="text-primary-600">{{ totalPages }}</b> pages
        </div>

        <div class="divider"></div>
      }
    }

    @if (!isNewUI) {
      <div class="flex items-center gap-2">
        <span>{{ 'common.items-per-page' | translate }}</span>
        <p-dropdown
          [(ngModel)]="pagination.size"
          (onChange)="onSizeChange(pagination.size)"
          [options]="options"
          appendTo="body"
          dropdownIcon="icon-wl-arrow-drop-down ml-5 !text-neutral-600">
          @if (type === 'lead' && options.at(-1) === -1) {
            <ng-template pTemplate="item" let-option>
              <div class="flex items-center gap-2">
                @if (option === -1) {
                  <span class="!text-neutral-1000">Show all</span>
                } @else {
                  <span class="!text-neutral-1000">{{ option }}</span>
                }
              </div>
            </ng-template>
            <ng-template pTemplate="selectedItem" let-value>
              @if (value === -1) {
                <span>Show all</span>
              } @else {
                <span>{{ value }}</span>
              }
            </ng-template>
          }
        </p-dropdown>
      </div>
    }

    <!-- Paginator -->
    <div class="flex items-center gap-1">
      <button
        (click)="pagination.page > 0 ? onPageChange(pagination.page - 1) : null"
        [ngClass]="[pagination.page > 0 ? '' : 'opacity-50', isNewUI ? 'bg-white' : '']"
        class="h-8 min-w-8 flex items-center justify-center border rounded-sm">
        <i class="icon-wl-chevron-left text-6"></i>
      </button>

      <button
        *ngFor="let page of pageNumbers"
        [ngClass]="
          page === pagination.page
            ? isNewUI
              ? 'text-white bg-primary-600'
              : 'bg-neutral-alpha-200A'
            : isNewUI
              ? 'bg-white'
              : 'border'
        "
        (click)="onPageChange(page)"
        class="p-1.5 max-h-8 min-w-8 flex items-center justify-center rounded-sm font-medium">
        @if (page >= 0) {
          {{ page + 1 }}
        } @else {
          ...
        }
      </button>

      <button
        (click)="pagination.page < totalPages - 1 ? onPageChange(pagination.page + 1) : null"
        [ngClass]="[pagination.page < totalPages - 1 ? '' : 'opacity-50', isNewUI ? 'bg-white' : '']"
        class="h-8 min-w-8 flex items-center justify-center rounded-sm border">
        <i class="icon-wl-chevron-right text-6"></i>
      </button>
    </div>

    <div class="flex items-center gap-2">
      <span>{{ 'common.jump-to' | translate }}</span>
      <input type="text" pInputText class="h-8 w-12 text-center" [(ngModel)]="jumpTo" (keyup.enter)="onJumpPage()" />
    </div>

    @if (isNewUI) {
      <p-dropdown
        [(ngModel)]="pagination.size"
        (onChange)="onSizeChange(pagination.size)"
        [options]="options"
        appendTo="body"
        styleClass="h-8"
        dropdownIcon="icon-wl-arrow-drop-down ml-5 !text-neutral-600">
        <ng-template pTemplate="selectedItem">
          <div>{{ pagination.size }} / page</div>
        </ng-template>
      </p-dropdown>
    }
  </div>
</div>
